import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import { type IFlightFilters } from "../../types/interfaces";

export interface FlightFiltersContextValue {
  filters: IFlightFilters | null;
  defaultFilters: IFlightFilters | null;
  activeFilters: Record<keyof IFlightFilters, boolean> | null;
  updateFilters: Dispatch<SetStateAction<IFlightFilters | null>>;
}

export const FlightFiltersContext =
  createContext<FlightFiltersContextValue | null>(null);

export const useFlightFiltersContext = () => {
  const context = useContext(FlightFiltersContext);
  if (!context) {
    throw new Error(
      "useFlightFiltersContext must be used within a FlightFiltersProvider",
    );
  }
  return context;
};
